var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#13828F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 22.75L18.25 18.25M9.25 14.5C9.25 15.1894 9.3858 15.8721 9.64963 16.5091C9.91347 17.146 10.3002 17.7248 10.7877 18.2123C11.2752 18.6998 11.854 19.0865 12.4909 19.3504C13.1279 19.6142 13.8106 19.75 14.5 19.75C15.1894 19.75 15.8721 19.6142 16.5091 19.3504C17.146 19.0865 17.7248 18.6998 18.2123 18.2123C18.6998 17.7248 19.0865 17.146 19.3504 16.5091C19.6142 15.8721 19.75 15.1894 19.75 14.5C19.75 13.8106 19.6142 13.1279 19.3504 12.4909C19.0865 11.854 18.6998 11.2752 18.2123 10.7877C17.7248 10.3002 17.146 9.91347 16.5091 9.64963C15.8721 9.3858 15.1894 9.25 14.5 9.25C13.8106 9.25 13.1279 9.3858 12.4909 9.64963C11.854 9.91347 11.2752 10.3002 10.7877 10.7877C10.3002 11.2752 9.91347 11.854 9.64963 12.4909C9.3858 13.1279 9.25 13.8106 9.25 14.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.517990cdf11c9c4873df4fa4a9c05bc0.svg";
export { ForwardRef as ReactComponent };